import React, { useCallback, useEffect } from 'react';
import css from '~/features/dashboard/components/quick-song-entry/styles.module.scss';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { NumberInput, TextInput } from '~/features/dashboard/components/add-deal/components/text-input';
import { INewQuickSongForm } from '~/models/music/new-song/formInputs';
import { createNewQuickSongEntryUpdateThunk, getMusicsThunk } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { useForm } from 'react-hook-form';
import { DatePickerController } from '~/features/dashboard/components/date-picker-controller';
import { push } from 'connected-react-router';

interface MyCreateSongProps {
    creatorId: number;
    rows: any[];
}

export const UpdateQuickSongEntry: React.FC<MyCreateSongProps> = ({ creatorId, rows }) => {
    const dispatch = useThunkDispatch();

    const { register, handleSubmit, setValue, control } = useForm<INewQuickSongForm>({
        defaultValues: {},
    });

    const onSubmit = useCallback(
        (data: INewQuickSongForm) => {
            dispatch(createNewQuickSongEntryUpdateThunk({ ...data, creatorId })).then(() =>
                setTimeout(() => {
                    dispatch(getMusicsThunk({ creatorId })).finally(() => dispatch(push(`/creators-list/${creatorId}/dashboard/songs/table/`)));
                }, 500)
            );
        },
        [dispatch] // eslint-disable-line
    );

    useEffect(() => {
        rows.map((item, index) => {
            setValue(`song[${index}].songRef`, item.songRef);
            setValue(`song[${index}].songName`, item.songName);
            setValue(`song[${index}].entryID`, item.entryID);
            setValue(`song[${index}].writerName`, item.writerName);
            setValue(`song[${index}].writerShare`, item.writerShare);
            setValue(`song[${index}].pubName`, item.pubName);
            setValue(`song[${index}].pubShare`, item.pubShare);
            setValue(`song[${index}].artist`, item.artist);
            setValue(`song[${index}].releaseDate`, item.releaseDate);
            setValue(`song[${index}].releaseYear`, item.releaseYear);
            return item;
        });
    }, [rows]); // eslint-disable-line

    return (
        <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
            {rows.length > 0 && (
                <>
                    <TableContainer component={Paper} className={css.tableQuickDates}>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" width={'5%'}>
                                        №
                                    </TableCell>
                                    <TableCell align="left">Song Name</TableCell>
                                    <TableCell align="left">Writer Name</TableCell>
                                    <TableCell align="left">Writer Share</TableCell>
                                    <TableCell align="left">Pub Name</TableCell>
                                    <TableCell align="left">Pub Share</TableCell>
                                    <TableCell align="left">Main Artist</TableCell>
                                    <TableCell align="left">First Release Date</TableCell>
                                    <TableCell align="left">First Release Year</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row, index) => (
                                    <TableRow key={`row-${row.songRef}`}>
                                        <TableCell align="center" width={'5%'}>
                                            {index + 1}
                                        </TableCell>
                                        <TableCell align="left">
                                            <input type="hidden" name={`song[${index}].songRef`} ref={register} />
                                            <input type="hidden" name={`song[${index}].entryID`} ref={register} />
                                            <TextInput label={''} name={`song[${index}].songName`} register={register} />
                                        </TableCell>
                                        <TableCell align="left">
                                            <TextInput label={''} name={`song[${index}].writerName`} register={register} />
                                        </TableCell>
                                        <TableCell align="left">
                                            <NumberInput
                                                type={'number'}
                                                label={''}
                                                name={`song[${index}].writerShare`}
                                                register={register}
                                                min={0}
                                                max={100}
                                                step={0.01}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <TextInput label={''} name={`song[${index}].pubName`} register={register} />
                                        </TableCell>
                                        <TableCell align="left">
                                            <NumberInput
                                                type={'number'}
                                                label={''}
                                                name={`song[${index}].pubShare`}
                                                register={register}
                                                min={0}
                                                max={100}
                                                step={0.01}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <TextInput label={''} name={`song[${index}].artist`} register={register} />
                                        </TableCell>
                                        <TableCell align="left">
                                            <DatePickerController name={`song[${index}].releaseDate`} control={control} label="" row />
                                        </TableCell>
                                        <TableCell align="left">
                                            <TextInput label={''} name={`song[${index}].releaseYear`} register={register} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Button className={css.saveButton} type={'submit'}>
                        Submit
                    </Button>
                </>
            )}
        </form>
    );
};
